import { render, staticRenderFns } from "./RealEstateBuildingEdit.vue?vue&type=template&id=38015de4&"
import script from "./RealEstateBuildingEdit.vue?vue&type=script&lang=js&"
export * from "./RealEstateBuildingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports